<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>


        <div class="bolck_box">
            <a-card  size="small" title="">
                <a-row>
                    <a-col :span="4">

                    </a-col>
                    <a-col :span="16">
                        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                            <a-form-model-item  label="平台类型编码" ref="platformtype"  prop="platformtype" >
                                <a-input v-if="is_vue_task" v-model="record.platformtype" @blur=" () => {$refs.platformtype.onFieldBlur();}" />
                                <span v-else>{{record.platformtype}}</span>
                            </a-form-model-item>
                            <a-form-model-item ref="platformtypename" label="平台类型名称" prop="platformtypename">
                                <a-input v-if="is_vue_task" v-model="record.platformtypename" @blur=" () => {$refs.platformtypename.onFieldBlur();}" />
                                <span v-else>{{record.platformtypename}}</span>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                </a-row>

            </a-card>
        </div>



        <a-button v-if="is_vue_task" type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
const m_title = {
    'add_platformtype':'新增平台类型',
    'detail_platformtype':'查看平台类型',
    'edit_platformtype':'编辑平台类型',
};

export default {
    components:{
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                platformtype: [
                    { required: true, message: '请输入平台类型编码', trigger: 'blur' },
                ],
                platformtypename:[
                    { required: true, message: '请输入平台类型名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                platformtype:'',//--
                platformtypename:'',//--
            }
        };
    },

    methods: {
        handleCodeChange(item){
            this.record.channelcode = item.value;
            this.record.channelname = item.text;
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitData();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        submitData(){
            this.confirmLoading = true;
            const { params } = this.$route;
            if(params.action == 'edit_platformtype'){
                this.$store
                    .dispatch({
                        type: "mcmsmanager/updateMcmsPlatformtype",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
            else if(params.action == 'add_platformtype'){
                this.record.id = '';
                //新增
                this.$store
                    .dispatch({
                        type: "mcmsmanager/insertMcmsPlatformtype",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.platformtype = 'PLATFROM-000'
        },

        getDetail(id){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsPlatformtypesOne",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    
                }
            });
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_platformtype";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_platformtype'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}


.bolck_box{
    padding: 20px;
}


</style>
